<header class="account__setup--header">
  <span class="app__form--attribute--title font-semibold text-base"> Finish Account Set Up </span>
  <button matTooltipPosition="above" data-dismiss="modal" class="bg-white" data-cy="close-button" (click)="closeSideNav()">
    <span class="material-icons relative bg-white">clear</span>
  </button>
</header>

<div *ngIf="screenWidth <= 480">
  <account-setup-nav
    #AccountSetupNavChildComponent
    [tabs]="steps"
    [selectedIndex]="!steps[0].completed ? 0 : !steps[1].completed ? 1 : !steps[2].completed ? 2 : !steps[3].completed ? 3 : 0"
    (menuSelectionEventEmitter)="menuSelectionEventhandler($event)"
  ></account-setup-nav>
</div>

<section class="flex" [style]="screenWidth > 480 ? 'height: 90vh' : 'margin-bottom: 60px'">
  <div class="nav w-[253px]" *ngIf="screenWidth > 480">
    <nav class="w-full" data-cy="account-setup-fixed-nav">
      <ul class="w-full pt-5">
        <li
          *ngFor="let step of steps; let index = index; let last = last"
          class="app__stepper__config-stepitem"
          [class]="step.completed ? 'hover:text-[#1AA140] cursor-default' : ''"
          [ngClass]="{
            'app__stepper__config-stepitem-completed': step.completed,
            'app__stepper__config-stepitem-notcompleted': !step.completed,
            'app__stepper__config-stepitem-selected': step.status == 'active',
          }"
          (click)="!step.completed && handleSidenavMenuNavigation(index)"
        >
          <img *ngIf="step.completed" class="app__stepper__image-checked" src="../../../../assets/images/check-green.svg" alt="green-check" />
          {{ step.name }}
        </li>
      </ul>
    </nav>
  </div>

  <div [ngClass]="{ 'account__setup--body': !switchFromUser, 'account__setup-impersonating-body': switchFromUser }">
    @if(currentActiveIndex == 0 && steps[currentActiveIndex].status == 'active'){
    <!-- Basic Information -->
    <div class="flex flex-col justify-start h-full">
      <form class="w-full flex flex-col justify-start h-full" [formGroup]="userBasictInformationForm" *ngIf="user$ | async as user">
        <p class="app__form--attribute--title text-xl font-semibold text-[#53565B]">
          {{ loginStateObject.first_name | capitalizeFirstWord }}'s <span class="text-k-blue"> {{ steps[currentActiveIndex].name }} </span>
        </p>
        <div class="h-[96%] overflow-auto mt-4">
          <div>
            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable"><span class="font-normal">Prefix</span> (Optional)</mat-label>
                <mat-select disableOptionCentering panelClass="move-select-popup" matNativeControl formControlName="prefix" [(ngModel)]="user.prefix">
                  @for(prefix of prefixes;track prefix){
                  <mat-option class="hide-check-box" [value]="prefix">{{ prefix }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="fill" class="form-design-ui" data-cy="first-name-form-field">
                <mat-label class="automtic-form-desing-lable font-normal">First Name</mat-label>
                <input
                  matInput
                  placeholder="First Name"
                  formControlName="first_name"
                  [(ngModel)]="user.first_name"
                  data-cy="first-name-input"
                  required
                />
                @if (userBasictInformationForm.controls['first_name'].value == '') {
                <mat-error> First name is required </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui" data-cy="middle-name-form-field">
                <mat-label class="automtic-form-desing-lable font-normal">Middle Name</mat-label>
                <input matInput placeholder="Middle Name" formControlName="middle_name" [(ngModel)]="user.middle_name" data-cy="middle-name-input" />
              </mat-form-field>

              <mat-form-field appearance="fill" class="form-design-ui" data-cy="last-name-form-field">
                <mat-label class="automtic-form-desing-lable font-normal">Last Name</mat-label>
                <input matInput placeholder="Last Name" formControlName="last_name" [(ngModel)]="user.last_name" data-cy="last-name-input" required />
                @if (userBasictInformationForm.controls['last_name'].value == '') {
                <mat-error> Last name is required </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui">
                <mat-label class="automtic-form-desing-lable">
                  <span class="font-normal"> Suffix </span>
                  (Optional)</mat-label
                >
                <mat-select disableOptionCentering panelClass="move-select-popup" matNativeControl formControlName="suffix" [(ngModel)]="user.suffix">
                  @for(suffix of suffixes;track suffix){
                  <mat-option class="hide-check-box" [value]="suffix">{{ suffix }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill" class="form-design-ui" data-cy="your-self-form-field">
                <mat-label class="automtic-form-desing-lable"> <span class="font-normal">Nickname</span> (Optional) </mat-label>
                <input matInput placeholder="Nickname" formControlName="your_self" [(ngModel)]="user.your_self" data-cy="your-self-input" />
              </mat-form-field>
            </div>

            <div class="basic__Info--wrapper gap-[10px]">
              @if(!!user.birthdate || userBasictInformationForm.controls['birthdate'].value){
              <ng-container [ngTemplateOutlet]="dateInput"> </ng-container>
              } @else if(userBasictInformationForm.controls['birthdate'].dirty || userBasictInformationForm.controls['birthdate'].touched){
              <ng-container [ngTemplateOutlet]="dateInput"> </ng-container>
              } @else {
              <ng-container [ngTemplateOutlet]="dateInput"> </ng-container>
              }
              <ng-template #dateInput>
                <reusable-date-input
                  [ngClass]="'w-[49%]'"
                  [labelClass]="'font-normal'"
                  [classStyle]="' app__medium--height--form w-full'"
                  [title]="'Date of Birth'"
                  [ngClassStyle]="
                    userBasictInformationForm.controls['birthdate'].dirty &&
                    userBasictInformationForm.controls['birthdate'].touched &&
                    userBasictInformationForm.controls['birthdate'].invalid
                      ? 'automtic-form-desing-error'
                      : ''
                  "
                  [hasMaxDate]="true"
                  formControlName="birthdate"
                  [maxDate]="todayDate"
                  [value]="
                    userBasictInformationForm.controls['birthdate'].dirty ? userBasictInformationForm.controls['birthdate'].value : user.birthdate
                  "
                  (dateChangeEmitter)="handleDateChange($event)"
                  (changeEmitter)="handleDateChange($event)"
                  [appearance]="'fill'"
                >
                </reusable-date-input>
              </ng-template>
              <mat-form-field appearance="fill" class="form-design-ui app__medium--height--form relative genderValue" data-cy="gender-form-field">
                <span
                  class="material-icons text-base cursor-pointer absolute"
                  [matTooltip]="
                    'We ask for gender to ensure that inverse relationship types are defined appropriately (e.g. the inverse of \'Mother\' is \'Daughter\')'
                  "
                  [ngClass]="{ 'top-[2px] left-[56px] !important': genderHasValue() || !!user?.gender }"
                >
                  info_outline
                </span>
                <mat-label class="automtic-form-desing-lable font-normal">Gender</mat-label>
                <mat-select
                  disableOptionCentering
                  panelClass="move-select-popup"
                  matNativeControl
                  formControlName="gender"
                  [(ngModel)]="user.gender"
                  required
                  (selectionChange)="handleFieldChange($event, 'gender', 'basic')"
                >
                  <mat-option class="hide-check-box" value="Male">Male</mat-option>
                  <mat-option class="hide-check-box" value="Female">Female</mat-option>
                  <mat-option class="hide-check-box" value="Other"> Other</mat-option>
                </mat-select>
                <mat-error> Gender is required </mat-error>
              </mat-form-field>
            </div>
            <div class="basic__Info--wrapper">
              <mat-form-field appearance="fill" class="form-design-ui basic__Info--email--input">
                <mat-label class="automtic-form-desing-lable font-normal"> Account Email </mat-label>
                <input matInput placeholder="Account Email" [value]="user.email" [disabled]="true" [class.disabled__form--input]="true" />
                @if(user.email){
                <span matSuffix> <img src="../../../../assets/images/check.svg" class="mr-[8px]" /></span>
                }
              </mat-form-field>
            </div>
          </div>
        </div>
        <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
        <div class="flex justify-between items-center">
          <a class="text-sm font-open-sans not-italic font-medium cursor-pointer" data-cy="back-button" (click)="showPreviousStep()">
            <img src="assets/images/arraw-back.svg" alt="" />
            Back</a
          >
          <button
            data-cy="continue-button"
            [disabled]="userBasictInformationForm.invalid"
            [class]="userBasictInformationForm.valid ? 'app__btn--primary w-[158px] py-3 px-12' : 'app__btn--disabled w-[158px] py-3 px-12'"
            (click)="showNextStep()"
          >
            Continue
          </button>
        </div>
      </form>
    </div>
    }@else if(currentActiveIndex == 1 && steps[currentActiveIndex].status == 'active'){
    <!-- Contact information -->
    <div class="w-full h-full">
      <form class="w-full h-full" [formGroup]="userContactInformationForm" *ngIf="user$ | async as user">
        <div class="w-full flex flex-col h-full">
          <p class="app__form--attribute--title text-xl font-semibold text-[#53565B]">
            {{ loginStateObject?.nick_name ?? loginStateObject.first_name | capitalizeFirstWord }}'s
            <span class="text-k-blue"> {{ steps[currentActiveIndex].name }} </span>
          </p>
          <p class="app__form--attribute--title text-sm font-normal leading-6 text-[#18191C] mt-[-8px]">
            Only users who {{ loginStateObject?.nick_name ?? loginStateObject.first_name | capitalizeFirstWord }} adds to their network will be able
            to view their preferred contact information.  
          </p>
          <div class="h-[96%] overflow-auto mt-4">
            <div class="flex flex-col justify-between h-fit">
              <p class="app__form--attribute--title text-[#898F9E] text-[14px] track-[-0.07px] font-semibold">Preferred Contact Methods</p>
              <div class="basic__Info--wrapper">
                <mat-form-field appearance="fill" class="form-design-ui" data-cy="email-form-field">
                  <mat-label class="automtic-form-desing-lable"> Email</mat-label>
                  <input
                    matInput
                    type="email"
                    placeholder="Contact Email"
                    formControlName="contact_email"
                    [(ngModel)]="user.contact_email"
                    data-cy="email-input"
                  />
                  <mat-error
                    *ngIf="
                      userContactInformationForm.controls['contact_email'].errors && userContactInformationForm.controls['contact_email'].value !== ''
                    "
                  >
                    Incorrect email address.
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-design-ui" data-cy="phone-number-form-field">
                  <mat-label class="automtic-form-desing-lable">Phone Number</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Telephone"
                    [(ngModel)]="user.phone_no"
                    formControlName="phone_no"
                    data-cy="phone-number-input"
                  />
                  <mat-error
                    *ngIf="userContactInformationForm.controls['phone_no'].errors && userContactInformationForm.controls['phone_no'].value !== ''"
                  >
                    15 characters is exceeded
                  </mat-error>
                </mat-form-field>
              </div>
              <p class="app__form--attribute--title text-[#898F9E] text-[14px] track-[-0.07px] font-semibold">Mailing Address</p>
              <div class="contact__Info--wrapper w-full">
                <mat-form-field appearance="fill" class="form-design-ui mobile-full-width-form w-full" data-cy="country-form-field">
                  <mat-label class="automtic-form-desing-lable">Country</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Country"
                    aria-label="Country"
                    [formControl]="userContactInformationForm.get('country')"
                    [matAutocomplete]="auto"
                    [(ngModel)]="user.country"
                    (ngModelChange)="handleFieldChange($event, 'country', 'contact')"
                    data-cy="country-input"
                  />
                  <mat-error
                    *ngIf="
                      userContactInformationForm.controls['country'].errors && userContactInformationForm.controls['country'].value?.length > 100
                    "
                  >
                    100 characters is exceeded
                  </mat-error>
                  <mat-error
                    *ngIf="
                      userContactInformationForm.controls['country'].value &&
                      userContactInformationForm.controls['country'].touched &&
                      userContactInformationForm.controls['country'].value?.length <= 100
                    "
                  >
                    Country not found
                  </mat-error>
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option
                      *ngFor="let countries of countryData | filterWorkspace : userContactInformationForm.get('country').value"
                      [value]="countries.name"
                      (onSelectionChange)="selectEvent($event, countries?.isoCode)"
                    >
                      {{ countries.name }}
                    </mat-option>
                  </mat-autocomplete>
                  <div matSuffix *ngIf="user.country" (click)="user.country = ''">
                    <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                  </div>
                </mat-form-field>
              </div>
              <div class="contact__Info--wrapper w-full">
                <mat-form-field appearance="fill" class="form-design-ui w-full">
                  <mat-label class="automtic-form-desing-lable"> Street Address </mat-label>
                  <input
                    #streetAddressInput
                    type="text"
                    placeholder="Street Address (including Unit or Apartment Number)"
                    aria-label="Street"
                    matInput
                    formControlName="street"
                    [(ngModel)]="user.street"
                  />
                  <mat-error
                    *ngIf="userContactInformationForm.controls['street'].errors && userContactInformationForm.controls['street'].value !== ''"
                  >
                    100 characters is exceeded
                  </mat-error>
                  @if(user.street) {
                  <span matSuffix (click)="user.street = ''">
                    <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                  </span>
                  }
                </mat-form-field>
              </div>

              <div class="contact__Info--wrapper flex max-[480px]:block">
                <mat-form-field appearance="fill" class="form-design-ui w-[399px] max-[480px]:w-full" data-cy="state-form-field">
                  <mat-label class="automtic-form-desing-lable">State</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="State"
                    [formControl]="userContactInformationForm.get('state')"
                    [matAutocomplete]="auto2"
                    [(ngModel)]="user.state"
                    (ngModelChange)="handleFieldChange($event, 'state', 'contact')"
                    data-cy="state-input"
                  />
                  <mat-error *ngIf="userContactInformationForm.controls['state'].errors && userContactInformationForm.controls['state'].value !== ''">
                    100 characters is exceeded
                  </mat-error>
                  <mat-autocomplete #auto2="matAutocomplete">
                    <mat-option *ngIf="!StateData?.length && isStateDataLoading" disabled>Loading states...</mat-option>
                    <mat-option *ngIf="!StateData?.length && !isStateDataLoading && userContactInformationForm.controls['country'].value" disabled>
                      No state
                    </mat-option>
                    <mat-option *ngIf="!StateData?.length && !isStateDataLoading && !userContactInformationForm.controls['country'].value" disabled>
                      Please select country
                    </mat-option>
                    <div *ngIf="StateData?.length">
                      <mat-option
                        *ngFor="let state of StateData | filterWorkspace : userContactInformationForm.get('state').value"
                        [value]="state.name"
                        (onSelectionChange)="selectEvent($event, state?.countryCode, state?.isoCode)"
                      >
                        {{ state.name }}
                      </mat-option>
                    </div>
                  </mat-autocomplete>
                  <div matSuffix *ngIf="user.state" (click)="user.state = ''">
                    <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                  </div>
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-design-ui w-[399px] max-[480px]:w-full" data-cy="city-form-field">
                  <mat-label class="automtic-form-desing-lable">City</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="City"
                    aria-label="City"
                    [formControl]="userContactInformationForm.get('city')"
                    [matAutocomplete]="auto3"
                    [(ngModel)]="user.city"
                    (ngModelChange)="handleFieldChange($event, 'city', 'contact')"
                    data-cy="city-input"
                  />
                  <mat-error *ngIf="userContactInformationForm.controls['city'].errors && userContactInformationForm.controls['city'].value !== ''">
                    100 characters is exceeded
                  </mat-error>
                  <mat-autocomplete #auto3="matAutocomplete">
                    <mat-option *ngIf="!CityData?.length && isCityDataLoading" disabled>Loading cities...</mat-option>
                    <mat-option *ngIf="!CityData?.length && !isCityDataLoading && userContactInformationForm.controls['state'].value" disabled>
                      No city
                    </mat-option>
                    <mat-option *ngIf="!CityData?.length && !isCityDataLoading && !userContactInformationForm.controls['state'].value" disabled
                      >Please select country and state
                    </mat-option>
                    <div *ngIf="CityData?.length">
                      <mat-option
                        *ngFor="let city of CityData | filterWorkspace : userContactInformationForm.get('city').value"
                        [value]="city.name"
                        (onSelectionChange)="selectEvent($event)"
                      >
                        {{ city.name }}
                      </mat-option>
                    </div>
                  </mat-autocomplete>
                  <div matSuffix *ngIf="user.city" (click)="user.city = ''">
                    <mat-icon class="close-input-icon text-[#898F9E] hover:cursor-pointer mr-5">close</mat-icon>
                  </div>
                </mat-form-field>
                <mat-form-field appearance="fill" class="form-design-ui w-[399px] max-[480px]:w-full">
                  <mat-label class="automtic-form-desing-lable">Zip</mat-label>
                  <input
                    matInput
                    type="text"
                    placeholder="Zip"
                    aria-label="Zip"
                    formControlName="zip"
                    [formControl]="userContactInformationForm.get('zip')"
                    [(ngModel)]="user.zip"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
          <div class="flex justify-between items-center">
            <a class="text-sm font-open-sans not-italic font-medium cursor-pointer" data-cy="back-button" (click)="showPreviousStep()">
              <img src="assets/images/arraw-back.svg" alt="" />
              Back</a
            >
            <button class="app__btn--primary w-[158px] py-3 px-12" data-cy="continue-button" (click)="showNextStep()">Continue</button>
          </div>
        </div>
      </form>
    </div>
    }@else if(currentActiveIndex == 2 && steps[currentActiveIndex].status == 'active'){
    <!-- Location setting -->
    <div class="flex flex-col justify-start h-full">
      <form class="w-full flex flex-col justify-start h-full" [formGroup]="locationSettingForm" *ngIf="user$ | async as user">
        <p class="app__form--attribute--title text-xl font-semibold text-[#53565B]">
          {{ loginStateObject.nick_name ?? loginStateObject.first_name | capitalizeFirstWord }}'s <span class="text-k-blue"> Location </span>
        </p>
        <p class="app__form--attribute--title text-sm font-normal leading-6 text-[#18191C] mt-[-8px]">
          Identify the country and state/province where {{ loginStateObject?.nick_name ?? loginStateObject.first_name | capitalizeFirstWord }} is
          currently domiciled. This information helps us create predictive insights. 
        </p>

        <div class="h-[96%] overflow-auto mt-4">
          <mat-form-field
            appearance="fill"
            class="automtic-form-desing-form-only add-automtic-form-desing w-full max-[767px]:w-full"
            data-cy="legal-Residence-form-field"
          >
            <mat-label class="automtic-form-desing-lable">Country of Residence</mat-label>
            <mat-select
              formControlName="residence_country"
              [(ngModel)]="user.residence_country"
              (ngModelChange)="handleFieldChange($event, 'residence_country', 'location')"
              [disableOptionCentering]="true"
              panelClass="app__inline--mat--select--dropdown"
              required
              (selectionChange)="handleCountryResidenceSelection($event.value)"
            >
              <div class="app__discovery--header--search--field w-[94%] h-9 border-[1.2px] border-[#B1ACB066] font-open-sans not-italic m-3 mt-5">
                <div class="app__centered-item w-full h-full px-5">
                  <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="14px" height="14px" /></span>
                  <input
                    class="h-full w-full ml-2 border-none outline-none text-[13px]"
                    [formControl]="searchStringCountry"
                    type="text"
                    placeholder="Search"
                    autocomplete="off"
                    data-cy="legal-Residence-input"
                    (keydown.space)="$event.stopPropagation()"
                  />
                </div>
              </div>
              <div
                class="max-h-[170px] min-h-[70px] overflow-y-auto mb-2"
                *ngIf="(countryData | filterWorkspace : searchStringCountry.value)?.length && !isCountryDataLoading; else showTemplateLoader"
              >
                <mat-option
                  class="mr-1"
                  *ngFor="let countries of countryData | filterWorkspace : searchStringCountry.value; let i = index"
                  [value]="countries.name"
                >
                  {{ countries.name }}
                </mat-option>
              </div>
              <ng-template #showTemplateLoader>
                <div *ngIf="isCountryDataLoading">
                  <mat-option
                    class="app__placeholder--option w-full ph-item border-none p-0 m-0 h-[20px]"
                    *ngFor="let count of [{}, {}, {}, {}]; let i = index"
                  >
                    <div class="ph-col-12 h-full">
                      <div class="ph-row">
                        <div class="ph-col-12 h-6"></div>
                      </div>
                    </div>
                  </mat-option>
                </div>
                <div class="h-[50px]" *ngIf="!isCountryDataLoading && (countryData | filterWorkspace : searchStringCountry.value)?.length == 0">
                  <span class="px-4 mt-4 text-gray-400"> Country not found </span>
                </div>
              </ng-template>
            </mat-select>
          </mat-form-field>
          @if(locationSettingForm.get('residence_country').value == 'United States'){
          <mat-form-field
            appearance="fill"
            class="automtic-form-desing-form-only add-automtic-form-desing w-full max-[767px]:w-full"
            data-cy="state-Residence-form-field"
          >
            <mat-label class="automtic-form-desing-lable">State of Residence</mat-label>
            <mat-select
              formControlName="residence_state"
              [(ngModel)]="user.residence_state"
              (ngModelChange)="handleFieldChange($event, 'residence_state', 'location')"
              [disableOptionCentering]="true"
              panelClass="app__inline--mat--select--dropdown"
              required
            >
              <div class="app__discovery--header--search--field w-[94%] h-9 border-[1.2px] border-[#B1ACB066] font-open-sans not-italic m-3 mt-5">
                <div class="app__centered-item w-full h-full px-5">
                  <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="14px" height="14px" /></span>
                  <input
                    class="h-full w-full ml-2 border-none outline-none font-open-sans font-normal"
                    matInput
                    type="text"
                    [formControl]="searchStringState"
                    placeholder="Search"
                    autocomplete="off"
                    data-cy="state-Residence-input"
                    (keydown.space)="$event.stopPropagation()"
                  />
                </div>
              </div>
              <div
                class="max-h-[170px] min-h-[70px] overflow-y-auto mb-2"
                *ngIf="(stateData2 | filterWorkspace : searchStringState.value)?.length && !isStateDataLoading; else showTemplateLoader"
              >
                <mat-option class="mr-1" *ngFor="let state of stateData2 | filterWorkspace : searchStringState.value" [value]="state.name">
                  {{ state.name }}
                </mat-option>
              </div>
              <ng-template #showTemplateLoader>
                <div *ngIf="isStateDataLoading">
                  <mat-option
                    class="app__placeholder--option w-full ph-item border-none p-0 m-0 h-[20px]"
                    *ngFor="let count of [{}, {}, {}, {}]; let i = index"
                  >
                    <div class="ph-col-12 h-full">
                      <div class="ph-row">
                        <div class="ph-col-12 h-6"></div>
                      </div>
                    </div>
                  </mat-option>
                </div>
                <div class="h-[50px]" *ngIf="!isStateDataLoading && (stateData2 | filterWorkspace : searchStringState.value)?.length == 0">
                  <span class="px-4 mt-4 text-gray-400"> State not found </span>
                </div>
              </ng-template>
            </mat-select> </mat-form-field
          >} @if(userContactInformationForm.get('country').value){
          <div class="app__common--copy--btn app__centered-item app__form--attribute--title" (click)="copyDataFromContactInfo()">
            <span> Copy data from Contact Information </span>
          </div>
          }
        </div>
        <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
        <div class="flex items-center justify-between">
          <a class="text-sm font-open-sans not-italic font-medium cursor-pointer" data-cy="back-button" (click)="showPreviousStep()">
            <img src="assets/images/arraw-back.svg" alt="" />
            Back</a
          >
          <button
            data-cy="continue-button"
            [disabled]="locationSettingForm.invalid"
            [class]="locationSettingForm.valid ? 'app__btn--primary w-[158px] py-3 px-12' : 'app__btn--disabled w-[158px] py-3 px-12'"
            (click)="showNextStep()"
          >
            Continue
          </button>
        </div>
      </form>
    </div>
    }@else if(currentActiveIndex == 3 && steps[currentActiveIndex].status == 'active'){
    <!-- Profile picture -->
    <div class="w-full flex flex-col justify-between h-full">
      <div class="w-full h-full">
        <p class="app__form--attribute--title text-xl font-semibold text-[#53565B]">
          {{ loginStateObject.nick_name ?? loginStateObject.first_name | capitalizeFirstWord }}'s <span class="text-k-blue"> Profile Picture </span>
        </p>
        <div class="h-[96%] overflow-auto pt-4">
          <div class="image__uploader--dropzone--full p-4">
            <div *ngIf="!showdiv && !imageUploadedSuccess">
              <div
                class="image__uploader--dropzone--img relative"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave()"
                (drop)="onDrop($event)"
              >
                <img mat-card-image src="../../../assets/images/profile-placeholder.png" alt="Profile Image" class="h-[200px]" />
              </div>
            </div>
            <div *ngIf="format == 'image'">
              <div class="mx-auto">
                <image-cropper
                  [imageChangedEvent]="imageChangedEvent"
                  [maintainAspectRatio]="true"
                  [containWithinAspectRatio]="containWithinAspectRatio"
                  [aspectRatio]="1"
                  [resizeToWidth]="180"
                  [resizeToHeight]="180"
                  [onlyScaleDown]="true"
                  [roundCropper]="true"
                  [canvasRotation]="canvasRotation"
                  [transform]="transform"
                  [alignImage]="'center'"
                  [style.display]="showCropper ? null : 'none'"
                  format="jpeg"
                  (imageCropped)="imageCropped($event)"
                  (imageLoaded)="imageLoaded()"
                  class="w-[180px] h-[180px] min-w-[180px] min-h-[180px]"
                ></image-cropper>
              </div>
            </div>
            <div *ngIf="imageUploadedSuccess && !showdiv" class="image__uploader--dropzone--img">
              <img mat-card-image [src]="userProfile" alt="Profile Image" style="border-radius: 100%; height: 180px" />
            </div>
            <div class="flex justify-center mt-4">
              <button
                type="submit"
                class="image__uplader--upload--img border-solid border border-[#25508e]"
                data-cy="upload-profile-picture-button"
                (click)="fileUpload.click()"
              >
                <img src="../../../../assets/images/upload.svg" />
                Upload Image
              </button>
            </div>
            <input
              type="file"
              style="display: none"
              #fileUpload
              (change)="fileChangeEvent($event)"
              id="fileUpload"
              data-cy="upload-profile-picture-input"
              name="fileUpload"
            />
          </div>
        </div>
      </div>
      <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
      <div class="flex justify-between items-center">
        <a class="text-sm font-open-sans not-italic font-medium cursor-pointer" data-cy="back-button" (click)="showPreviousStep()">
          <img src="assets/images/arraw-back.svg" alt="" />
          Back</a
        >
        <button class="app__btn--primary w-[158px] py-3 px-12" data-cy="continue-button" (click)="showNextStep()">Continue</button>
      </div>
    </div>
    }@else if(currentActiveIndex == 4 && steps[currentActiveIndex].status == 'active'){
    <!-- Status -->
    <div class="h-full w-full flex flex-col justify-start">
      <div
        class="h-[90%] overflow-auto pr-10 mb-5"
        [ngStyle]="{
          width: screenWidth > 480 ? 'calc(100% + 40px)' : ''
        }"
      >
        <div class="mr-[42px]">
          <div class="rounded-xl min-h-60 w-full border bg-white flex items-center justify-center flex-col py-8 px-12 mt-4">
            <p
              [class]="
                screenWidth > 480
                  ? 'sm:mb-2 text-xl text-center  text-[#53565B] font-semibold'
                  : 'sm:mb-[8px] text-xl leading-5 text-center text-[#53565B] font-semibold'
              "
            >
              Mark Account Set Up as complete ?
            </p>
            <!-- <p class="text-sm text-center px-13 text-[#18191C]">
              You can add, edit, or remove account detail at any point in the future from the network section of this account.
            </p> -->
            <div class="flex mt-6">
              <app-button-slide data-cy="complete-step-slidder" (isSubmitButtonActiveForSubMit)="submitAllFormAnswers($event)"></app-button-slide>
            </div>
            <div class="app__mark--complete--info">
              <img src="../../../../assets/images/mark-as-complete-info.svg" alt="mark-complete-info" />
              <span class="app__form--attribute--title">
                Marking this as complete will save all the information which has been added. This can be changed at any point in the future from the
                home page.
              </span>
            </div>
          </div>
        </div>
      </div>

      <mat-divider class="text-[#C1C2C5] w-full"></mat-divider>
      <div class="flex items-center justify-between">
        <a class="text-sm font-open-sans not-italic font-medium cursor-pointer" data-cy="back-button" (click)="showPreviousStep()">
          <img src="assets/images/arraw-back.svg" alt="" />
          Back</a
        >
        @if(currentActiveIndex < 4){
        <button
          data-cy="continue-button"
          class="app__btn--primary w-fit min-w-[158px] py-3 px-12"
          (click)="
            isAccountMarkedCompleted || (steps[0].completed && steps[1].completed && steps[2].completed && steps[3].completed)
              ? markAllAsComplete()
              : closeSideNav()
          "
        >
          Save and continue</button
        >}
      </div>
    </div>
    }
    <!-- <div *ngIf="showLoader">
      <div class="loading-spinner loader-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </div> -->
  </div>
</section>
